import g from 'glamorous'

const Headline = g.h2(({ theme }) => {
  return {
    fontSize: '25px'
  }
})

export default Headline



// WEBPACK FOOTER //
// ./src/components/Headline.tsx